// user.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { loadUserSuccess, setConnectedUser, updateUser } from './user.actions';
import { initialUserState } from '../appState.state';

export const userReducer = createReducer(
  initialUserState,
  on(loadUserSuccess, (state, { user }) => ({ ...state, user })),
  on(updateUser, (state, { user }) => ({ ...state, user })),
  on(setConnectedUser, (state, { user }) => ({
    ...state,
    connectedUser: user
  }))
);
